// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/Perks/components/BroadcastOfferModal.css
// module id = 2508
// module chunks = 0